import i18next from 'i18next';

export const getActions = (
  handleXLSExport,
  handleRefreshActionClick,
  handleFillProduction,
  handleClearQuantities,
  { enableReset = false, enableFillProduction = true, enableClearQuantities = true } = {},
) => {
  const actions = [];

  if (enableFillProduction) {
    actions.push({
      label: i18next.t('PRODUCTION.PLANNING.FILL_PRODUCTION'),
      icon: `/images/inpulse/bolt-black-small.svg`,
      handleClick: () => handleFillProduction(),
    });
  }

  if (enableClearQuantities) {
    actions.push({
      label: i18next.t('PRODUCTION.PLANNING.CLEAR_QUANTITIES'),
      icon: `/images/inpulse/trash-black-small.svg`,
      handleClick: () => handleClearQuantities(),
    });
  }

  actions.push({
    label: i18next.t('PRODUCTION.PLANNING.EXPORT_ACTION'),
    icon: `/images/inpulse/file-download-black-small.svg`,
    handleClick: handleXLSExport,
  });

  // Button with actions do not have 'isHidden' prop, only ListView actions have it
  if (enableReset) {
    actions.push({
      label: i18next.t('FORECAST.POS_PRODUCTION_PLANNING.RESET_WARNING_MODAL_TITLE'),
      icon: `/images/inpulse/refresh-black-small.svg`,
      handleClick: handleRefreshActionClick,
    });
  }

  return actions;
};
